import * as ng from 'angular';
import SecurityModule from '../components/security';
import DataModule from '../data';
import refs from "../../vendor-modules";
import { CustomerSettings, ICustomerSettingsService } from './customer-settings-service';
import { Session, ISessionService, ISessionState } from './session';
import { Themes, IThemesService } from './themes-service';
import { ToastMessage, IToastMessageService } from './toast-message-factory';

let servicesModule = ng.module("app.services", [
    refs.ngRouter,
    refs.ngMaterial,
    refs.ngGetText,
    DataModule.name,
    SecurityModule.name
]).service(CustomerSettings.name, CustomerSettings.factory)
    .service(Session.name, Session.factory)
    .service(Themes.name, Themes.factory)
    .service(ToastMessage.name, ToastMessage.factory);

export {
    servicesModule as ServicesModule, servicesModule,
    ICustomerSettingsService, ISessionService, IThemesService, IToastMessageService,
    ISessionState
};
export default servicesModule


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/services/index.ts